export default __webpack_public_path__ + "static/media/male-body-outline.27bc7d83.jpg";